import { PublicShell } from "../../components/Layouts";

export default function About() {
  return (
    <PublicShell>
      <main className="page">
        <div className="page-intro">
          <div className="eyebrow">ABOUT WORLD HELP AGENCY</div>
          <h1>We make digital participation<br /><em>legible.</em></h1>
          <p>World Help Agency is built on three principles: clarity about what each participation means, verifiability of every financial step, and accountability for everyone involved.</p>
        </div>
        <div className="prose">
          <h3>Our mission</h3>
          <p>We give members a structured way to participate in a digital economy without hiding the mechanics. Every number on the dashboard has an auditable source — a confirmed deposit, a daily production record, a referral commission, or a reviewed withdrawal.</p>
          <h3>How we operate</h3>
          <p>Packages are defined by the administrator and shown transparently. Deposits are verified against BNB Smart Chain. Referral commissions are computed on activation, with the current published rates snapshotted into each transaction so historical rewards stay stable even if future rates change.</p>
          <h3>Why BEP20?</h3>
          <p>BNB Smart Chain offers low fees and fast finality for USDT transfers. It is a common standard that most wallets support out of the box.</p>
        </div>
      </main>
    </PublicShell>
  );
}
